<mce-page-with-navigation>

    <h1>Help & Support</h1>

    <section>

        <h2>Help</h2>
        <p>
            You can find valuable assistance in the <a [href]="knowledgeBaseUrl" target="_blank" rel="noopener noreferrer" class="external-link">knowledge base on the main myCableEngineering website</a>.
            This resource is designed to help you navigate any questions or challenges you may have.
        </p>
        <p>
            <a [href]="knowledgeBaseUrl" target="_blank" rel="noopener noreferrer" class="external-link">Open App Help in the Knowledge Base </a>
        </p>
        <p>
            <a [href]="fqaUrl" target="_blank" rel="noopener noreferrer" class="external-link">Open FAQ in the Knowledge Base </a>
        </p>
    </section>

    <section>
        <h2>Support - Self Help</h2>
        <p>
            If you are running into issues, there are a few things you can try prior to opening a ticket:
        <p>
            <ul class="mx-8 mb-8 flex flex-col gap-4">
                <li><strong>Knowledge Base</strong> - provides general help and guidance to get you through any problems.</li>
                <li><strong>Check Data</strong> - check all your data to ensure it is correct, consistent, and realistic.  If 'Save' is provented with an error message, hover over the message to see a list of invalid fields.</li>
                <li><strong>Hard Refresh</strong> - pressing 'ctrl' + 'F5' forces a hard refresh of the browser, downloading all application files again.  This may help if you local files have become stale or corrupted.</li>
                <li><strong>Browser</strong> - to elimiate browser settings or extensions causing issues, you can try running the application in Incognito mode or a different browser.</li>
            </ul>
    </section>

    <section>
        <h2>Support - Ticket</h2>
        <p>If you still need assistance, you can contact support directly using the support widget.</p>

        <p>
            When opening a support ticket, the more information provided, the quicker and easier it will
            be for us to resolve the issue.   Please include the following with any ticket:
        </p>
        <ul class="mx-8 mb-8 flex flex-col gap-4">
            <li>
                <strong>Reference</strong> - for issues related to a specific project or cable, include the
                reference number. Having the reference number will help us locate the project or cable
                with the issue. You can find a project or cable reference as follows:
            </li>

            <li>
                <ol class="mx-8 flex list-decimal flex-col gap-2">
                    <li>In the list of projects or cables, click the more <mat-icon>more_vert</mat-icon> icon, and click on reference at the bottom. This will copy the reference to your clipboard for pasting into the ticket.</li>
                    <li>In the project or edit screen, click the <mat-icon>chat_info</mat-icon> icon to copy the reference to the clipboard.</li>
                </ol>
            </li>



            <li><strong>Issue</strong> - providing as many details as possible about the query or issue will help us resolve it more quickly.</li>
            <li><strong>Reproduction</strong> - provide the necessary steps to reproduce any issue. Being able to reproduce the issue is halfway to solving it.</li>
            <li><strong>Screenshots</strong> - attach any relevant screenshots or documents, which may assist in answering the ticket.</li>
            <li><strong>Miscellaneous</strong> - to help eliminate certain factors outside our control that may be contributing to any issue, please provide details on the Browser and Device being used to run the application.</li>
        </ul>
        <p>

        <div class="support-panel">
        <mat-expansion-panel [expanded]="supportFormExpanded()" (opened)="supportFormExpanded.set(true)" (closed)="supportFormExpanded.set(false)">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <span class="support-panel-header-content">
                        <mat-icon>contact_support</mat-icon>
                        <span>Contact Us</span>
                    </span>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div id="zsfeedbackwidgetdiv"></div>
        </mat-expansion-panel>
        </div>
    </section>

</mce-page-with-navigation>


